import { FiArrowRight, FiBook, FiBookOpen, FiHelpCircle, FiMinus, FiShield } from "react-icons/fi";
import { s1 } from "../assets";
import styles from "../style";
import { Reveal } from "./reveal";
import FeatureAccord from "./FeatureCard_accordion";
import { features } from "../constants";
import { Link } from "react-router-dom";

const CTA = () =>  {
  return (
    <div className="w-full flex flex-col md:flex-row md:gap-20 gap-10 items-start justify-center py-40 px-10">
        <Reveal className="flex flex-col gap-4 items-start md:items-end py-40 pb-16">
            <h2 className="text-sm font-semibold">
                Join Our Mission
            </h2>
            <h2 className="pt-4 xs:text-md text-md font-semibold max-w-[300px]">
                Collaborate
            </h2>
            <h2 className="xs:text-md text-md font-semibold max-w-[300px] text-secondary">
                With Us
            </h2>
        </Reveal>     

        <Reveal className="flex flex-col items-start">
            <p className={`xs:text-mm text-sm font-semibold text-start max-w-[600px]`}>
                Over the years, we've helped unlock opportunities for thousands. From expanding access to education, to improving livelihoods across communities.
            </p>
            <p className={`xs:text-sm text-ss text-start my-6 max-w-[600px]`}> 
                This impact is only possible through shared effort and long-term collaboration. As we continue to grow, your involvement can help extend this reach and deepen the difference we make together.
            </p> 
            <div className="flex flex-row gap-2 my-10 items-center gap-4">
                <Link to="/contact">
                    <Reveal>
                        <button className="flex flex-row items-center p-2 gap-4 bg-second h-[40px] px-4">
                            <FiArrowRight size={20} className="text-pfourth" />
                            <h2 className="text-sm font-semibold text-fourth">
                                Book Meeting
                            </h2>
                        </button>
                    </Reveal>
                </Link>
                <span className="border-r border-2 border-fourth h-[36px] w-[0.5px] rounded-lg"></span>
                <Link to="/company">
                    <Reveal>
                        <button className="flex flex-row items-center justify-center gap-2">
                            <div className="w-[40px] h-[40px] bg-second items-center justify-center flex  mr-2">
                                <FiArrowRight size={20} className="text-fourth" />
                            </div>
                            <h2 className="text-sm font-semibold">
                                Our Mission
                            </h2>
                        </button>
                    </Reveal>
                </Link>
            </div>
        </Reveal>
    </div>
)};

export default CTA;